import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccordion, LazyAccordionPanel, LazyAccordionHeader, LazyAccordionContent, LazyTabs, LazyTabList, LazyTab, LazyTabPanels, LazyTabPanel, LazyToast } from '#components'
const lazyGlobalComponents = [
  ["Accordion", LazyAccordion],
["AccordionPanel", LazyAccordionPanel],
["AccordionHeader", LazyAccordionHeader],
["AccordionContent", LazyAccordionContent],
["Tabs", LazyTabs],
["TabList", LazyTabList],
["Tab", LazyTab],
["TabPanels", LazyTabPanels],
["TabPanel", LazyTabPanel],
["Toast", LazyToast],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
